export const CHART_TYPE = {
	LINE_CHART: 'LineChart',
	HISTOGRAM: 'Histogram',
	COMPOSITE_CHART: 'ComposedChart'
};

export const SIMULATION_TYPE = {
	DC: 'DC',
	TRANSIENT: 'Transient',
	MONTECARLO_DC: 'Montecarlo_DC'
};

export const UNITS_SIGN = {
	VOLT: 'V',
	AMPER: 'A',
	MILLI_AMPER: 'mA',

	PICO_FARAD: 'pF',
	NANO_FARAD: 'nF',
	MICRO_FARAD: 'µF',
	MILLI_FARAD: 'mF',
	FARAD: 'F',

	PICO_HENRY: 'pH',
	NANO_HENRY: 'nH',
	MICRO_HENRY: 'µH',
	MILLI_HENRY: 'mH',
	HENRY: 'H',

	DECIBEL: 'dB',
	HERTZ: 'Hz',
	WATT: 'W',
	CELSIUS: '°C',
	CELSIUSWATT: '°C/W',
	COULOMB: 'C',

	MILLI_OHM: 'mΩ',
	OHM: 'Ω',
	KILO_OHM: 'kΩ',
	MEGA_OHM: 'MΩ',

	NANO_SECOND: 'ns',
	MICRO_SECOND: 'µs',
	MILLI_SECOND: 'ms',
	SECOND: 's',

	PERCENT: '%',
	NOUNITS: '-'
};

export const TABLE_DATA_SOURCE = {
	WD: 'WD',
	PRT: 'PRT'
};
